import { render } from "./ModalCertificateCreator.vue?vue&type=template&id=37a23e12&scoped=true"
import script from "./ModalCertificateCreator.vue?vue&type=script&lang=js"
export * from "./ModalCertificateCreator.vue?vue&type=script&lang=js"

import "./ModalCertificateCreator.vue?vue&type=style&index=0&id=37a23e12&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37a23e12"]])

export default __exports__